import styled from "styled-components";
import { BbotAlert } from "top-component-library";

export const LegacyLinkAlert = styled(BbotAlert)`
  margin-bottom: 16px;
`;

export const Section = styled.div`
  margin-bottom: 24px;
`;

export const BalanceLabel = styled.div`
  color: var(--color-neutral__placeholder);
  font-size: 14px;
`;

export const BalanceValue = styled.div`
  font-size: 28px;
  font-weight: 600;
`;

export const LowBalanceWarning = styled.div`
  color: var(--color-error__regular);
  margin: 8px 0 16px;
`;

export const SettingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
`;
